<template lang="pug">
    #salary-settlement-update
        model-form(
            loading-text='Cargando liquidación de sueldo...'
            ref='form'
            reset-text='restablecer'
            submit-text='guardar'
            v-bind='formProps'
            v-model='formData'
            @reset='reset'
            @submit='submit'
        )
            template( slot='footer-actions' )
                v-btn(
                    block
                    class='ml-3'
                    color='secondary' 
                    :disabled='formData.confirmed'
                    @click='submitConfirm'
                ) confirmar
            template( slot='header-actions' )
                v-btn( 
                    color='secondary' 
                    style='margin: -8px 8px;'
                    @click='submitContract'
                ) contrato &nbsp;
                    v-icon call_made
                v-btn( 
                    color='secondary' 
                    style='margin: -8px 8px;'
                    @click='submitPreview'
                ) previsualizar &nbsp;
                    v-icon zoom_in
                v-btn( 
                    color='secondary' 
                    style='margin: -8px 8px;' 
                    @click='submitPrint'
                ) imprimir &nbsp;
                    v-icon print
        v-dialog( v-model='dialog' :width='1080' )
            v-card
                v-card-title.grey.darken-4.white--text.subheading.font-weight-medium.text-uppercase {{ title }}
                    v-btn( color='white' flat icon style='margin: -8px 0 -8px auto' @click='submitClose' )
                        v-icon close
                v-card-text.pa-0
                    salary-settlement-details( 
                        ref='details'
                        v-bind='detailProps'
                    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import SalarySettlementModel from '@/models/HumanResource/HrSalarySettlement'
    import SalarySettlementFields from '@/views/HumanResource/HrSalarySettlement/partials/HrSalarySettlementFields'
    //
    import SalarySettlementDetails from '@/views/HumanResource/HrSalarySettlement/HrSalarySettlementDetails'
    //
    export default {
        name: 'salary-settlement-create',
        components: {
            ModelForm,
            SalarySettlementDetails,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            detailProps() {
                return {
                    salarySettlementId: Number(this.$route.params.id)
                }
            },

            /**
             * 
             */
            fieldsProps() {
                return {
                    indicators: this.indicators,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    editable: this.formData.can_edit,
                    fields: SalarySettlementFields(this.fieldsProps),
                    loading: this.busy,
                    switchEdit: this.formData.can_edit,
                    title: this.title,
                }
            },

            /**
             *
             */
            title() {
                return `Liquidación de sueldo #${this.$route.params.id}`
            },
        },
        data() {
            return {
                busy: false,
                dialog: false,
                formData: {
                    extra_hh_hours: 0,
                    extra_hh_minutes: 0,
                    discount_hh_hours: 0,
                    discount_hh_minutes: 0,
                },
                indicators: [],
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            confirm() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .then(this.toConfirm)
                    .then(this.$refs.form.setWait)
            },

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(SalarySettlementModel, error.response.data))
            },

            /**
             *
             */
            fetch() {
                return SalarySettlementModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             *
             */
            refresh() {
                this.reset()
            },

            /**
             * 
             */
            reset() {
                this.setBusy(true).then(this.fetch).then(this.setBusy)
            },

            /**
             *
             */
            async setBusy(busy = false) {
                this.busy = busy
            },

            /**
             *
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * 
             */
            submit() {
                this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .then(this.$refs.form.setWait)
            },

            /**
             *
             */
            submitClose() {
                this.dialog = false
            },

            /**
             * 
             */
            submitConfirm() {
                this.setWarningSnackbar({
                    title: '¿Desea confirmar la liquidación de sueldo?',
                    message: 'Una vez confirmada no se puede editar.',
                    confirm: 'confirmar',
                })
            },

            /**
             *
             */
            submitContract() {
                this.$router.push({ 
                    name: 'contract-update',
                    params: {
                        id: this.formData.hr_contract_id,
                    }
                })
            },
            
            /**
             *
             */
            submitPreview() {
                this.$refs.details.getGeneralInfoRemunerations()
                this.dialog = true
            },
            
            /**
             *
             */
            submitPrint() {
                this.$refs.details.submitPrint()
            },

            /**
             * 
             */
            successConfirm() {
                this.setSuccessSnackbar('Liquidación de sueldo confirmada exitosamente.')
            },

            /**
             * 
             */
            successUpdate() {
                this.setSuccessSnackbar('Liquidación de sueldo actualizada exitosamente.')
            },

            /**
             *
             */
            toConfirm() {
                return this.formData
                    .confirm()
                    .attach()
                    .then(this.successConfirm)
                    .then(this.refresh)
                    .catch(this.error)
            },

            /**
             *
             */
            toUpdate() {
                return this.formData
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.refresh)
                    .catch(this.error)
            },
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch (val) {
                    case 'confirmar': return this.confirm()
                }
            }
        },
        mounted() {
            this.setTitleTopBar(this.title)
            this.reset()
        },
    }
</script>